import React, { useState } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import useDataFlights from '../../../../../../dataHooks/useDataFlights'
import useForm from '../../../../../../hooks/useForm';
import SharedFlightForm from "./SharedFlightForm";
import FlightForm from "./FlightForm";

export default ({
  flightData = {},
  eventId,
  onClose,
  onSuccess,
}) => {

  const { Departing: departingFlightData, Returning: returningFlightData } = flightData;

  let isEdit = false;
  let initFlightType = 'Both';
  let sharedFlightObj = {};
  if (departingFlightData && returningFlightData) {
    initFlightType = 'Both';
    sharedFlightObj = departingFlightData;
    isEdit = true;
  } else if (departingFlightData && !returningFlightData) {
    initFlightType = 'Departing';
    sharedFlightObj = departingFlightData;
    isEdit = true;
  } else if (returningFlightData && !departingFlightData) {
    initFlightType = 'Returning';
    sharedFlightObj = returningFlightData;
    isEdit = true;
  }

  const {
    addNewFlight,
    updateFlight,
  } = useDataFlights()

  const sharedFormSchema = {
    requiredFields: ['personFlying', 'airline', 'flightConfirmation', 'flightType'],
    initData: {
      ...sharedFlightObj,
      flightType: initFlightType
    }
  };

  const sharedFormData = useForm(sharedFormSchema)

  const departingFormSchema = {
    requiredFields: ['airlineFlightNumber', 'takeOff', 'takeOffCity', 'landingCity', 'takeOffTime', 'landingTime'],
    initData: departingFlightData
  };

  const departingFormData = useForm(departingFormSchema)

  const returningFormSchema = {
    requiredFields: ['airlineFlightNumber', 'takeOff', 'takeOffCity', 'landingCity', 'takeOffTime', 'landingTime'],
    initData: returningFlightData
  };

  const returningFormData = useForm(returningFormSchema)


  const flightType = sharedFormData.values.flightType;

  const [isBusy, setIsBusy] = useState(false);

  const checkIsValid = () => {
    const sharedFormIsValid = sharedFormData.isValid();

    let departingFormIsValid;
    if (['Departing', 'Both'].includes(flightType)) {
      departingFormIsValid = departingFormData.isValid();
    }

    let returningFormIsValid;
    if (['Returning', 'Both'].includes(flightType)) {
      returningFormIsValid = returningFormData.isValid();
    }

    let flightFormsAreValid;
    if (flightType === 'Both') {
      flightFormsAreValid = (departingFormIsValid && returningFormIsValid)
    } else if (flightType === 'Departing') {
      flightFormsAreValid = departingFormIsValid;
    } else if (flightType === 'Returning') {
      flightFormsAreValid = returningFormIsValid;
    }

    return (sharedFormIsValid && flightFormsAreValid)
  }

  const onClickSubmit = async () => {
    if (!isBusy && checkIsValid()) {
      setIsBusy(true)

      try {
        if (['Departing', 'Both'].includes(flightType)) {
          const saveObj = {
            ...departingFormData.values,
            ...sharedFormData.values,
            flightType: 'Departing',
            eventId
          }
          if (isEdit) {
            await updateFlight({ _id: departingFlightData._id, ...saveObj })
          } else {
            await addNewFlight(saveObj)
          }
        }
        if (['Returning', 'Both'].includes(flightType)) {
          const saveObj = {
            ...returningFormData.values,
            ...sharedFormData.values,
            flightType: 'Returning',
            eventId
          }
          if (isEdit) {
            await updateFlight({ _id: returningFlightData._id, ...saveObj })
          } else {
            await addNewFlight(saveObj)
          }
        }

        setIsBusy(false)

        onSuccess()
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Confirm'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Add Flights'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <SharedFlightForm formData={sharedFormData} isEdit={isEdit} />
        { 
          ['Departing', 'Both'].includes(flightType) &&
          <div>
            <div style={{
              color: '#565656',
              fontSize: '17px',
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>
              {'Departing Flight'}
            </div>
            <FlightForm formData={departingFormData} />
          </div>
        }
        {
          ['Returning', 'Both'].includes(flightType) &&
          <div>
            <div style={{
              color: '#565656',
              fontSize: '17px',
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>
              {'Returning Flight'}
            </div>
            <FlightForm formData={returningFormData} />
          </div>
        }
      </div>
    </Modal>
  )
}